import React, { useEffect, useState } from "react";
import DetailsCall from "../DetailsCall/DetailsCall";
import classes from "./Call.module.sass";

function Call(props) {
  const {
    date,
    durationLabel,
    icon,
    isOpen,
    duration,
    duration_translation,
    minutes_translation,
    url,
    hour } = props;

  const [showDetailCall, setShowDetailCall] = useState(false);

  useEffect(() => {
    if (isOpen) {
      clickOnTop()
    }
  }, [isOpen])

  const clickOnTop = () => {
    setShowDetailCall(!showDetailCall)
  };

  return (

    <div className={`${classes.call}`}>
      <div className={`${classes.rowContainer}`}>
        <div
          className={classes.sliderMainContent}>
          <div className={`row`} style={{
            minHeight: '70px',
            margin: 0,
            width: '100%',
            cursor: 'pointer'
          }}
            onClick={clickOnTop}>
            <div className={`col-3 ${classes.mainColumn}`}>
              <div className={classes.callIcon} dangerouslySetInnerHTML={{ __html: icon }} />
              <div className={classes.labelTitle}>{durationLabel}</div>
            </div>
            <div className="col-7" >
              <div className={classes.duration}>
                <span className={classes.label}>{duration_translation}</span>
                <span className={classes.counter} >
                  {duration} {minutes_translation}
                </span>

              </div>

            </div>



            <div className={`col-2 ${classes.dateColumn}`}>
              <div className={classes.weekDay}>{hour}</div>
              <div className={classes.date}>{date}</div>

            </div>
          </div>


          <div className={classes.date}>
            {showDetailCall ? <DetailsCall callURL={url} insideBox={true} /> : null}
          </div>


        </div>

      </div>
      <div className={classes.menuContainer}>
        
      </div>
    </div>

  );
}

export default Call;
